import React from "react";

const PARTNERS = [
  {
    name: "Deckhouse",
    url: "/external-assets/eh35cms1_Deckhouse_logo.png",
    tone: "dark",
    testid: "partner-deckhouse",
  },
  {
    name: "Delta Solutions",
    url: "/external-assets/fvct6cvp_Delta_Solutions_logo.png",
    tone: "dark",
    testid: "partner-delta",
  },
  {
    name: "ICL Системные технологии",
    url: "/external-assets/c7x5vrsm_ICL_logo.png",
    tone: "dark",
    testid: "partner-icl",
  },
  {
    name: "IT FB Group",
    url: "/external-assets/u4jegp4v_IT_FB_logo.png",
    tone: "dark",
    testid: "partner-itfb",
  },
  {
    name: "Machine Intelligence Laboratory",
    url: "/external-assets/pzsb35o6_MIL_logo.png",
    tone: "dark",
    testid: "partner-mil",
  },
  {
    name: "РСК",
    url: "/external-assets/tkyh3xq0_rsc_logo.png",
    tone: "dark",
    testid: "partner-rsc",
  },
  {
    name: "Скала",
    url: "/external-assets/3m2dz9f1_skala_logo.png",
    tone: "light",
    testid: "partner-skala",
  },
];

export const Partners = () => {
  return (
    <section id="partners" data-testid="partners-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 mb-12">
          <div className="lg:col-span-7">
            <div className="mono text-xs uppercase tracking-[0.22em] text-brand-cyan mb-3">
              / 06 — Партнёрства
            </div>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              Технологические альянсы,
              <br />
              <span className="text-muted">которые масштабируют внедрение.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 self-end">
            <p className="text-muted text-sm leading-relaxed">
              Совместная разработка, интеграция и поставка решений с лидерами российского
              рынка K8s-инфраструктуры, GPU-серверов и DCIM-систем.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4">
          {PARTNERS.map((p) => {
            const isLight = p.tone === "light";
            return (
              <div
                key={p.testid}
                data-testid={p.testid}
                className={`group relative aspect-square rounded-2xl border overflow-hidden hover:border-brand/40 hover:-translate-y-1 transition-all duration-300 ${
                  isLight
                    ? "bg-white border-ink-text/10"
                    : "bg-[#0A0F1E] border-ink-text/8"
                }`}
                style={{
                  boxShadow:
                    "0 1px 2px rgba(10,15,30,0.04), 0 8px 24px rgba(10,15,30,0.06)",
                }}
              >
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                  style={{
                    background:
                      "radial-gradient(ellipse 80% 60% at 50% 100%, rgba(0,153,201,0.18), transparent 60%)",
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center p-5">
                  <img
                    src={p.url}
                    alt={p.name}
                    className="max-w-[85%] max-h-[80%] w-auto h-auto object-contain"
                    loading="lazy"
                  />
                </div>
                <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-cyan/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            );
          })}
        </div>

        <div
          className="mt-10 flex items-center justify-center gap-3 mono text-[10px] uppercase tracking-[0.22em] text-muted-deep"
          data-testid="partners-tagline"
        >
          <span className="w-10 h-px bg-ink-text/10" />
          Технологические лидеры
          <span className="w-10 h-px bg-ink-text/10" />
        </div>
      </div>
    </section>
  );
};

export default Partners;
